import {showModal} from './modal';


/**
 *
 */
type VideoInfo = {
	error: boolean,
	type: string,
	videoId: string,
	embedUrl: string,
	viewUrl: string,
	autoplay: boolean,
	looping: boolean,
	sound: boolean,
	controls: boolean,
	posterImage: null
};


/**
 *
 */
const setupVideoModals = () =>
{
	const links = document.querySelectorAll( '[data-video-modal]' );

	links.forEach( link =>
	{
		const infoStr                = link.getAttribute( 'data-video-modal-info' ) || 'null';
		const ctaStr                 = link.getAttribute( 'data-video-modal-cta' ) || 'null';
		const info: VideoInfo | null = JSON.parse( infoStr );
		const cta                    = JSON.parse( ctaStr );
		let title                    = link.getAttribute( 'data-video-modal-title' ) || '';

		if (cta) {

			title = `
				<a href="${cta.url}" class="btn btn-primary">
					${cta.title}
				</a>
			`;
		}


		if (info) {

			link.addEventListener( 'click', e =>
			{
				e.preventDefault();

				let videoHtml: string;

				if (info.type === 'youtube') {

					videoHtml = `
						<iframe src="${info.embedUrl}?autoplay=1"></iframe>
					`;

				} else if (info.type === '') {

					videoHtml = `
						<video
							src="${info.embedUrl}"
							controls
							poster="${info.posterImage}"
						></video>
					`;

				} else {

					videoHtml = `
						<iframe src="${info.embedUrl}?autoplay=1"></iframe>
					`;
				}

				showModal(
					'video-modal',
					title,
					`<div class="video">${videoHtml}</div>`
				);
			} );
		}
	} );
};


/**
 *
 */
export default setupVideoModals;